import { DetailsEditor, FormContainer } from "uikit"
import FaqLinks from "components/FaqLinks"
import React from "react"
import { Button, Dropdown, Grid } from "semantic-ui-react"
import { accountTypes, accountTypesData } from "./accountTypes"
import { useStore } from "store"

const accountTypeOptions = accountTypesData.map(account => ({
  value: account.type,
  text: account.label
}))

const AccountTypeSelectGrid = ({
  data: {
    fields: { accountType },
    onSubmit,
    hasError,
    error
  },
  submitLabel = "Continue",
  onCancel
}) => {
  const [{ label, description, faqs }] = useStore(
    "contextuals",
    `Screen: addaccount`
  )

  return (
    <DetailsEditor
      heading={label}
      description={description}
      supplement={<FaqLinks items={faqs} />}
    >
      <Grid>
        <Grid.Row
          style={{
            background: "#edf7ff",
            padding: "3em",
            borderTop: "1px solid #ccc"
          }}
        >
          <Grid.Column textAlign="center">
            <Dropdown
              placeholder="Select Account Type"
              selection
              options={accountTypeOptions}
              {...accountType}
              error={!!accountType.error}
              data-testid="account_type"
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row centered style={{ minHeight: "20em" }}>
          <Grid.Column
            width={10}
            textAlign="center"
            style={{ fontSize: "16px", paddingTop: "21px", color: "#aaa" }}
          >
            {accountType.value
              ? accountTypes[accountType.value].description
              : "Please select the type of account you wish to add."}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={{ borderTop: "1px solid #ccc" }} columns={2}>
          <Grid.Column textAlign="left" style={{ paddingLeft: "2em" }}>
            <Button basic content="Cancel" onClick={onCancel} primary />
          </Grid.Column>
          <Grid.Column textAlign="right" style={{ paddingRight: "2em" }}>
            <Button
              content={submitLabel}
              onClick={onSubmit}
              primary
              name="continue"
              data-testid="continue"
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </DetailsEditor>
  )
}

const AccountTypeSelector = FormContainer(
  {
    accountType: {
      type: "string",
      required: true
    }
  },
  (fields, ...form) => {}
)(AccountTypeSelectGrid)

export default AccountTypeSelector
